import React from 'react';
import { useState } from 'react';
import AnimatedArrows from '../AnimatedArrows';

import './BettingPanelWizardInstructionsOverlay.css';

const BettingPanelWizardInstructionsOverlay = ({ showBlankOverlay }) => {

	const [showAfterAnimation, setShowAfterAnimation] = useState(false);
	const overlayClassName = showAfterAnimation ? ' show' : '';

	const handleAnimationEnd = evt => {
		const { animationName } = evt;

		if (animationName === 'fade-in') {
			setShowAfterAnimation(true);
			console.log('animationName', animationName);
		}
	}

	return (
		<div className={"crg-betting-panel-wizard-instructions-overlay" + overlayClassName} onAnimationEnd={handleAnimationEnd}>
			{!showBlankOverlay && 
			<div className={"crg-instruction-panel"}>
				<p>Select a word chain</p>			
				<AnimatedArrows />
			</div>
			}
		</div>
		);
}

export default BettingPanelWizardInstructionsOverlay;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/BettingPanelWizardInstructionsOverlay.jsx